import _ from 'lodash';
function reducer(state = [], action) {
    switch (action.type) {
        case 'HIGHLIGHTS/SET':
            return action.highlights;
        case 'HIGHLIGHTS/CLEAR':
            return null;
        case 'HIGHLIGHTS/UPDATE':
            let index = _.findIndex(state, v => v.idVideo === action.highlight.idVideo);
            if (index !== -1)
                return [...state.slice(0, index), action.clip, ...state.slice(index + 1)]
            return [...state, action.highlight];
        case 'VIDEOS/UPDATE':
            let index2 = _.findIndex(state, v => v.idVideo === action.video.idVideo);
            if (index2 !== -1)
                return [...state.slice(0, index2), action.video, ...state.slice(index2 + 1)]
            return [...state];
        default:
            return state;
    }
}

export default reducer;
